import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject, interval, switchMap, takeWhile } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { ReportsService } from './reports.service';
import moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'start_date', 'report', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  isLoading: Subject<boolean> = new Subject<boolean>();
  dateRange: Date[] | any = null;
  reportsMaster: any = [
    //{ "id": 1, "name": "Total Leads" },
    //{ "id": 2, "name": "Leads Sync With DMS" },
    { "id": 3, "name": "DD Leads" },
    { "id": 4, "name": "DSE Leads" },
    // { "id": 5, "name": "Booked Leads" },
    //{ "id": 6, "name": "Test Ride Leads" },
    //{ "id": 7, "name": "DSE Followup Leads" },
    { "id": 8, "name": "Daily Login" },
   // { "id": 9, "name": "Total Users" },
    //{ "id": 10, "name": "Total Login One Time" },
    { "id": 11, "name": "HL Website Total Leads" },
    //{ "id": 12, "name": "HO Website Total Leads" },
    //{ "id": 13, "name": "Yellow.ai Chatbot Total Leads" },
    // { "id": 14, "name": "CRM Total Leads" },
    { "id": 15, "name": "Only LMS Leads" },
    { "id": 16, "name": "Only DMS Leads" },
    // { "id": 17, "name": "Retailed Leads" },
    //{ "id": 18, "name": "Lost Leads" },
    //{ "id": 19, "name": "Call Leads" },
    // { "id": 20, "name": "DD Login" },
    // { "id": 21, "name": "DD NOT Login" },
    { "id": 22, "name": "DSE Login" },
    // { "id": 23, "name": "DSE NOT Login" },
    { "id": 28, "name": "Internal Overall Report" },
    { "id": 29, "name": "Internal Overall Report Test" },
   // { "id": 30, "name": "Existing Users Dump Report - Business Dashboard" },
    { "id": 'zra', "name": "ZRA Login Report" },
    { "id": 32, "name": "Super Admin Activity Log Report" },
    { "id": 33, "name": "DSE Successful Login" },
    { "id": 34, "name": "DD Enquiry Report (Follow-up test)" },
    { "id": 35, "name": "DD Successful Login" },
    { "id": 36, "name": "HL Website Pendency Report" },
   { "id": 37, "name": "Manpower Report(Advisable for 1 day)" },
   { "id": 38, "name": "Suzuki Model Log Report(Advisable for 1 day)" },
   { "id": 39, "name": "Dealer Master Report(Advisable for 1 day)" },
   { "id": 40, "name": "WebEnquiry Report" }

  ]

  bsConfig = {
    dateInputFormat: 'DD-MM-YYYY', // Set desired format
    showWeekNumbers: false,
    isAnimated: true
  };
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private reportsService: ReportsService) {
  }

  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
  }


  download() {
  }
  selectedMonth: Date = new Date(); // Current month and year by default
  // Last month
  maxMonth: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  );
  chosenMonthHandler(
    normalizedMonth: Date,
    datepicker: MatDatepicker<Date>
  ) {
    this.selectedMonth = normalizedMonth;
    datepicker.close();
  }

  selectedReportId: any = '';
  getReport() {
    console.log("selectedReportId:", this.selectedReportId, "dateRange: ", this.dateRange);
    if (this.selectedReportId === 'zra') {
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.reportsService.generateZRALoginReport().subscribe((response: any) => {
        let responseData = response.body
        if (responseData.responseCode == 200) {
            let url: any = responseData.data.download_url
            // Trigger the download
            if (url) {
              const link = document.createElement('a');
              link.href = url;
              link.download = ''; // Optional: Specify a default filename if needed
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.toastr.success('Report generated successfully! The file will download automatically, please wait...');
            }
        }
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.getList();
        this.toastr.success('Report generated successfully! The file will download automatically, please wait...');
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else if (!this.selectedReportId && !this.dateRange) {
      this.toastr.error('Please select a report and date range!');
      return;
    } else if (!this.selectedReportId) {
      this.toastr.error('Please select a report!');
      return;
    } 
    else if (this.selectedReportId != 30 && this.selectedReportId != 33  && this.selectedReportId != 35 && this.selectedReportId != 40 && (!this.dateRange || !this.dateRange[0] || !this.dateRange[1])) {
      this.toastr.error('Please select date range!');    
      return;
    } 
    else {
       let reqObject = {}
      if(this.selectedReportId == 30 || this.selectedReportId == 33 || this.selectedReportId == 35){
        reqObject = {
          report: parseInt(this.selectedReportId)
        }
      }
      else if (this.selectedReportId == 40) {
        reqObject = {
          report: parseInt(this.selectedReportId),
          month: moment(this.selectedMonth).format('M'),
          year: moment(this.selectedMonth).format('YYYY')
        }
      } 
      else {
       reqObject = {
        report: parseInt(this.selectedReportId),
        from: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        to: moment(this.dateRange[1]).format('YYYY-MM-DD')
      }
      }
      console.log("request:", reqObject)
      this.isLoading = new BehaviorSubject<boolean>(true);
      // if (this.selectedReportId == 29) {
      //   this.reportsService.generateInternalReport(reqObject).subscribe((response: any) => {
      //     let responseData = response.body

      //     if (responseData.responseCode == 200) {
      //       let url: any = responseData.data.download_url
      //       // Trigger the download
      //       if (url) {
      //         const link = document.createElement('a');
      //         link.href = url;
      //         link.download = ''; // Optional: Specify a default filename if needed
      //         document.body.appendChild(link);
      //         link.click();
      //         document.body.removeChild(link);
      //       }
      //       this.isLoading = new BehaviorSubject<boolean>(false);
      //       this.getList();
      //       this.toastr.success('Report generated successfully! The file will download automatically, please wait...');
      //     } else {
      //       this.isLoading = new BehaviorSubject<boolean>(false);
      //     }
      //   }, (err) => {
      //     this.isLoading = new BehaviorSubject<boolean>(false);
      //   });
      // }
     if (this.selectedReportId == 29) {
  this.reportsService.generateInternalReport(reqObject).subscribe(
    (response: any) => {
      let responseData = response.body;

      if (responseData.responseCode == 200) {
        // const reportId:any = responseData.data.report_id;

        // Start polling every 15 seconds
        this.toastr.info('Preparing report.... This may take a few moments.'); // Inform user that report is being prepared
        interval(10000)
          .pipe(
            switchMap(() => this.reportsService.getReportStatus()),
            takeWhile((res: any) => {
              const status = res.body.data.is_generating;
               console.log("Polling report status:", res.body.data,status); // Debug log
              // Show status to user
              if (status === true) {
                this.toastr.info('Generating report, please wait...');
                return true; // keep polling
              }

              if (status === false) {
                console.log('Report generated successfully.');
                this.getList();

                this.toastr.success('Report generated successfully.');
                return false; // stop polling
              }

              // if (status === 'FAILED') {
              //   this.toastr.error('Report generation failed');
              //   return false; // stop polling
              // }

              return true;
            }, true)
          )
          .subscribe();

      }

     this.isLoading = new BehaviorSubject<boolean>(false);
    },
    (err) => {
       this.isLoading = new BehaviorSubject<boolean>(false);
    }
  );
 
}else if (this.selectedReportId == 34) {
        this.reportsService.generateddEnquiryReport(reqObject).subscribe((response: any) => {
          let responseData = response.body
          if (responseData.responseCode == 200) {
            let url: any = responseData.data.download_url
            // Trigger the download
            if (url) {
              const link = document.createElement('a');
              link.href = url;
              link.download = ''; // Optional: Specify a default filename if needed
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.getList();
            this.toastr.success('Report generated successfully! The file will download automatically, please wait...');
          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
          }
        }, (err) => {
          this.isLoading = new BehaviorSubject<boolean>(false);
        });
      }
    else if (this.selectedReportId == 36) {
      const from = moment(this.dateRange[0]).format('YYYY-MM-DD')
      const to = moment(this.dateRange[1]).format('YYYY-MM-DD')
      let queryParams: any = 'from=' + from + '&to=' + to
      this.reportsService.generatePendencyReport(queryParams).subscribe({next: (response: any) => {

        let responseData = response.body // since GET usually doesn't have response.body

        if (responseData.responseCode == 200) {

          let url: any = responseData.data?.download_url;
          console.log("Generated report URL:", url); // Debug log
          if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          this.isLoading.next(false); // ✅ better than reassigning BehaviorSubject
          this.getList();

          this.toastr.success(
            'Report generated successfully! The file will download automatically, please wait...'
          );

        } else {
          this.isLoading.next(false);
        }
      },
      error: (err) => {
        this.isLoading.next(false);
        console.error(err);
      }
    });
}
  else if (this.selectedReportId == 37 || this.selectedReportId == 38 || this.selectedReportId == 39) {
      let reqObject = {
        report: parseInt(this.selectedReportId),
        from: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        to: moment(this.dateRange[1]).format('YYYY-MM-DD')
      }
      
      this.reportsService.generateDmsLogReport(reqObject).subscribe({next: (response: any) => {
        
        this.isLoading = new BehaviorSubject<boolean>(true);
        let responseData = response.body // since GET usually doesn't have response.body
        if (responseData.responseCode == 200) {

          let url: any = responseData.data?.download_url;
          if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          this.isLoading.next(false); // ✅ better than reassigning BehaviorSubject
          this.getList();

          this.toastr.success(
            'Report generated successfully! The file will download automatically, please wait...'
          );

        } else {
          this.isLoading.next(false);
          this.toastr.error(responseData.responseMessage || 'Failed to generate report');    
          return;

      //     this.toastr.error('Please select a report and date range!');
      // return;
        }
      },
      error: (err) => {
        this.isLoading.next(false);
        console.error(err);
      }
    });
}
else if (this.selectedReportId == 40) {
  this.reportsService.generateWebEnquiryLookBackReport(reqObject).subscribe(
    (response: any) => {
      let responseData = response.body;

      if (responseData.responseCode == 200) {
        // const reportId:any = responseData.data.report_id;

        // Start polling every 15 seconds
        this.toastr.info('Preparing report.... This may take a few moments.'); // Inform user that report is being prepared
        interval(10000)
          .pipe(
            switchMap(() => this.reportsService.getLookBackReportStatus()),
            takeWhile((res: any) => {
              const status = res.body.data.is_generating;
               console.log("Polling report status:", res.body.data,status); // Debug log
              // Show status to user
              if (status === true) {
                this.toastr.info('Generating report, please wait...');
                return true; // keep polling
              }

              if (status === false) {
                console.log('Report generated successfully.');
                this.getList();

                this.toastr.success('Report generated successfully.');
                return false; // stop polling
              }

              // if (status === 'FAILED') {
              //   this.toastr.error('Report generation failed');
              //   return false; // stop polling
              // }

              return true;
            }, true)
          )
          .subscribe();

      }

     this.isLoading = new BehaviorSubject<boolean>(false);
    },
    (err) => {
       this.isLoading = new BehaviorSubject<boolean>(false);
    }
  );
 
}


else {
        this.reportsService.generateReport(reqObject).subscribe((response: any) => {
          let responseData = response.body
          if (responseData.responseCode == 200) {
            let url: any = responseData.data.download_url
            // Trigger the download
            if (url) {
              const link = document.createElement('a');
              link.href = url;
              link.download = ''; // Optional: Specify a default filename if needed
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.getList();
            this.toastr.success('Report generated successfully! The file will download automatically, please wait...');
          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
          }
        }, (err) => {
          this.isLoading = new BehaviorSubject<boolean>(false);
        });
      }

    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.reportsService.getReportsList().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  getDownloadUrl(downloadUrl: string): string {
    return downloadUrl?.replace(
      'https://suzuki-mint-media-bucket-prod.s3.ap-south-1.amazonaws.com',
      environment.mintBucketurl
    ) || '';
  }
}
